module.exports = __webpack_public_path__ + "static/valuable-learning-growth-4f2b27b111caf0cf6febeeb674323fa8.webp";